// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"755":"3b8544d0","766":"f9d7d03e"}[chunkId] + ".chunk.css";
};